module.exports = __webpack_public_path__ + "static/media/products-kit.7083046a.png";